import React from "react";

const DeviceLoader = () => {
    return (
        <table className="rty-table loading">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>IP Address</th>
                    <th>Browser</th>
                    <th>Device</th>
                    <th>OS</th>
                    <th>Location</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <>{
                    [...Array(10)].map((_, i) => (
                        <tr key={i}>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                        </tr>
                    ))
                }</>
            </tbody>
        </table>
    )
}

export default DeviceLoader;